import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SET_USER } from "../../redux/user";
import Avatar from "./Avatar";

import dashboardIcon from "../../assets/images/icons/dashboard.svg";
import profileIcon from "../../assets/images/icons/profile.svg";
import passwordIcon from "../../assets/images/icons/changepassword.svg";

import logoutIcon from "../../assets/images/icons/logout.svg";
import { IoCloseOutline } from "react-icons/io5";

export default function ProfileMenu({ user }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const fullName =
    `${user?.first_name || ""} ${user?.middle_name || ""} ${
      user?.last_name || ""
    }`
      .replace(/\s+/g, " ")
      .trim() ||
    user?.full_name ||
    user?.name ||
    "Guest";

  const handleLogout = () => {
    localStorage.removeItem("GSTB_token");
    localStorage.removeItem("last_profile_photo_prompt");
    dispatch(SET_USER(null));
    navigate("/");
    setShow(false);
  };

  return (
    <Dropdown
      align="end"
      show={show}
      onToggle={(isOpen) => setShow(isOpen)}
      renderMenuOnMount={true}
    >
      <Dropdown.Toggle
        variant="link"
        bsPrefix="p-0 border-0 bg-transparent"
        id="profile-menu-toggle"
        className="text-decoration-none"
      >
        <Avatar user={user} size={38} />
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="profile-menu p-0"
        style={{ maxHeight: "calc(100vh - 100px)", overflowY: "auto" }}
      >
        <div className="profile-menu-header d-flex align-items-center justify-content-between px-3 py-3 border-bottom">
          <div className="d-flex align-items-center">
            <div>
              <Avatar user={user} size={40} />
            </div>
            <div className="ms-2">
              <div className="profile-menu-name inter-semibold">{fullName}</div>
            </div>
          </div>
          <div>
            <button
              type="button"
              className="profile-menu-close-btn"
              onClick={() => setShow(false)}
            >
              <IoCloseOutline size={20} />
            </button>
          </div>
        </div>

        <div className="profile-menu-list py-2">
          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={() => {
              navigate("/dashboard");
              setShow(false);
            }}
          >
            <span className="profile-menu-icon-wrap">
              <img src={dashboardIcon} alt="Dashboard" width={20} />
            </span>
            <span className="profile-menu-text">Dashboard</span>
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={() => {
              navigate("/profile");
              setShow(false);
            }}
          >
            <span className="profile-menu-icon-wrap">
              <img src={profileIcon} alt="Profile" width={20} />
            </span>
            <span className="profile-menu-text">My Profile</span>
          </Dropdown.Item>

          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={() => {
              navigate("/change-password");
              setShow(false);
            }}
          >
            <span className="profile-menu-icon-wrap">
              <img src={passwordIcon} alt="Password" width={20} />
            </span>
            <span className="profile-menu-text">Change Password</span>
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={handleLogout}
          >
            <span className="profile-menu-icon-wrap logout-icon-wrap">
              <img src={logoutIcon} alt="Logout" width={20} />
            </span>
            <span className="profile-menu-text text-danger">Logout</span>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
